import React, {FC, useCallback, useEffect, useState} from 'react';
import {OptionsProp} from '../../../../../../../constants/types';
import {useSnackbarHook} from '../../../../../../../hooks/useSnackbar';
import {AutocompleteField} from '../../../../../../common/formik/fields';
import {
  AutocompleteFieldProps
} from '../../../../../../common/formik/fields/AutocompleteField';

type EntityFieldProps = AutocompleteFieldProps & {
  loadOptionsPromise: () => Promise<unknown>,
  formatOptions: (data) => OptionsProp[]
}

const EntityField: FC<EntityFieldProps> = ({
  loadOptionsPromise, formatOptions, ...props
}) => {
  const [options, setOptions] = useState<OptionsProp[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const {addErrorToast} = useSnackbarHook();

  const loadOptions = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await loadOptionsPromise();

      setOptions(formatOptions(response));
    } catch (e) {
      addErrorToast(e?.message);
    } finally {
      setIsLoading(false);
    }
  }, [loadOptionsPromise, formatOptions]);

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <AutocompleteField
      {...props}
      options={options}
      loading={isLoading}
      disablePortal={false}
    />
  );
};

export default EntityField;
